import styled from 'styled-components';
import { Wrapper } from '../SavingsWorkspace/savingsworkspace.style';

export const PrivacyWrapper = styled(Wrapper)`
  background: #fff;
  padding-top: 24px;
`;

export const PrivacyList = styled.ul`
  max-width: 760px;
  margin: 0 auto;
  padding: 0;
  list-style: none;

  li {
    margin: 0 0 14px;
    padding: 16px 20px;
    border-left: 3px solid #7197d6;
    background: #f7faff;
    color: #343d48cc;
    font-size: 15px;
    line-height: 1.7;
  }

  strong {
    color: #0f2137;
    font-weight: 600;
  }
`;

export const Closing = styled.div`
  margin-top: 24px;
  text-align: center;

  a {
    color: #335d9f;
    font-weight: 600;
  }
`;
